import React from "react";
import loader from "../../img/loader.svg";
import "../../styles/Loader.css";

export interface LoadingSpinnerProps {
  children: React.ReactNode;
  loading: boolean;
  message?: string;
  styles?: React.CSSProperties;
}

const buildSpinner = (loading: boolean, message?: string, styles?: React.CSSProperties) => {
  if (loading) {
    return (
      <div className={"loading"} style={styles}>
        <div className={"loading-spinner-message"}>{message ? message : ""}</div>
          <img className={"spinner"} src={loader} alt="Loading"/>
      </div>
    )
  }

  return null;
}

const LoadingSpinner = (props: LoadingSpinnerProps) => {

  return (
    <div>
      {buildSpinner(props.loading, props.message, props.styles )}
      <div>{props.children}</div>
    </div>
  )
}

export default LoadingSpinner;
